// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__CeNQp","title":"ClientInsurance_title__3yQIB","itemText":"ClientInsurance_itemText__8uFL0"};